import { Tag } from "antd";
import { WaterIndexStatus } from "../enums/global.enums";
import { CSSProperties } from "react";

export function waterIndexStatusTagPipe(value?: string, style?: CSSProperties) {
    switch (value) {
        case WaterIndexStatus.PENDING: return <Tag color="var(--disabled-button)" style={style}>Chưa đọc</Tag>;
        case WaterIndexStatus.COMPLETED: return <Tag color="var(--warning-button)" style={style}>Chờ duyệt</Tag>;
        case WaterIndexStatus.CONFIRMED: return <Tag color="var(--success-button)" style={style}>Đã duyệt</Tag>;
        case WaterIndexStatus.CANCELLED: return <Tag color="var(--danger-button)" style={style}>Bị hủy</Tag>;
    }
    return <Tag color="default" style={style}>Chưa cập nhật</Tag>;
}